<template>
    <section class="grid-main">
        <form class="form-freight">
            <!-- 运费查询 s -->
            <ul class="fm-list">
                <li class="fm-item">
                    <label>{{ _ll('原寄地') }}</label>
                    <div class="ui-collapsible-select">
                        <span
                            class="fill-text"
                            :class="{ placeholder: selectOriginAreaName === '请选择原寄地' }"
                            @click="popRegionSelect({ isOrigin: true })"
                        >
                            {{ selectOriginAreaName }}</span
                        >
                        <div class="icon-wrapper">
                            <icon name="right"></icon>
                        </div>
                    </div>
                </li>
                <li class="fm-item">
                    <label>{{ _ll('目的地') }}</label>
                    <div class="ui-collapsible-select">
                        <span
                            class="fill-text"
                            :class="{ placeholder: selectDestAreaName === '请选择目的地' }"
                            @click="popRegionSelect({ isOrigin: false })"
                        >
                            {{ selectDestAreaName }}</span
                        >
                        <div class="icon-wrapper">
                            <icon name="right"></icon>
                        </div>
                    </div>
                </li>
                <li class="fm-item">
                    <label>{{ _ll('重量') }}(<span id="weightUnit">kg</span>)</label>
                    <input
                        class="input-text-line"
                        :value="weight"
                        type="number"
                        step="0.5"
                        placeholder="输入快件重量或体积进行查询"
                        @input="updateWeight"
                    />
                </li>
                <li class="fm-item">
                    <label>体积</label>
                    <div class="label-content clearfix">
                        <div class="label-cols">
                            <span class="label-box"
                                ><label>{{ _ll('长') }}</label
                                ><input :value="lengthInput" type="number" @input="updateLength" />
                                <span class="unit">cm</span>
                            </span>
                        </div>
                        <div class="label-cols">
                            <span class="label-box"
                                ><label>{{ _ll('宽') }}</label
                                ><input :value="widthInput" type="number" @input="updateWidth" />
                                <span class="unit">cm</span>
                            </span>
                        </div>
                        <div class="label-cols">
                            <span class="label-box"
                                ><label>{{ _ll('高') }}</label
                                ><input :value="heightInput" type="number" @input="updateHeight" />
                                <span class="unit">cm</span>
                            </span>
                        </div>
                    </div>
                </li>

                <li class="fm-item">
                    <label>{{ _ll('寄件时间') }}</label>
                    <div class="ui-collapsible-select" @click="showDateTimePicker">
                        <span class="fill-text">{{ sendTime }}</span>
                    </div>
                </li>
                <!-- 日期时间选择控件 -->
                <mt-datetime-picker
                    ref="picker"
                    type="date"
                    :value="initDate"
                    :startDate="startDate"
                    year-format="{value} 年"
                    month-format="{value} 月"
                    date-format="{value} 日"
                    @confirm="handleConfirm"
                />
                <my-time-picker :visible="showMyTimePickerFlg" @cancel="handleCancelTime" @confirm="handleConfirmTime" />
            </ul>
            <!-- 运费查询 e -->
            <p class="text-r">
                <span @click="showVolumeAndWeightDesc(true)">{{ _ll('为什么要同时输入体积和重量？') }}</span>
            </p>
            <div class="grid-btn">
                <span class="primary-btn big" :class="{ disabled: disabledBtn }" @click="!disabledBtn && getPayFee()">{{ _ll('查询') }}</span>
            </div>
        </form>
        <volume-weight-dialog v-show="showVolumeAndWeightFlg" @showVolumeAndWeightDesc="showVolumeAndWeightDesc" />
    </section>
</template>

<script>
import VolumeWeightDialog from './volume-weight-dialog'
import MyTimePicker from './my-time-picker'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('payFee')
export default {
    name: 'PayFeeForm',
    components: {
        'my-time-picker': MyTimePicker,
        'volume-weight-dialog': VolumeWeightDialog
    },
    data() {
        return {
            initDate: new Date(),
            startDate: new Date(new Date() - 7 * 24 * 3600 * 1000), // 设置开始时间
            showVolumeAndWeightFlg: false,
            showMyTimePickerFlg: false,
            selectedDate: ''
        }
    },
    computed: {
        ...mapState([
            'selectOriginAreaName',
            'selectOriginAreaCode',
            'selectDestAreaName',
            'selectDestAreaCode',
            'weight',
            'lengthInput',
            'widthInput',
            'heightInput',
            'sendTime'
        ]),
        ...mapGetters(['disabledBtn']),
        selectDestAreaName: {
            get: function () {
                return this.$store.state.payFee.selectDestAreaName
            },
            set: function (newVal) {
                this.$store.state.payFee.selectDestAreaName = newVal
            }
        },
        selectDestAreaCode: {
            get: function () {
                return this.$store.state.payFee.selectDestAreaCode
            },
            set: function (newVal) {
                this.$store.state.payFee.selectDestAreaCode = newVal
            }
        },
        sendTime: {
            get: function () {
                return this.$store.state.payFee.sendTime
            },
            set: function (newVal) {
                this.$store.state.payFee.sendTime = newVal
            }
        }
    },
    watch: {
        selectOriginAreaCode: function (val, oldVal) {
            if (val !== oldVal) {
                this.selectDestAreaCode = ''
            }
        },
        selectOriginAreaName: function (name, oldName) {
            if (name !== oldName) {
                this.selectDestAreaName = '请选择目的地'
            }
        }
    },
    methods: {
        ...mapMutations(['showResult', 'updateZipCode', 'updateWeight', 'updateLengthInput', 'updateWidthInput', 'updateHeightInput']),
        ...mapActions(['getPayFee']),
        popRegionSelect(opts) {
            this.$emit('regionShow', true, opts.isOrigin)
        },
        showRegionSelect() {
            this.showResult(false)
        },

        /**
         *  更新weight
         *  @param e
         */
        updateWeight(e) {
            this.$store.commit('payFee/updateWeight', e.target.value)
        },

        /**
         * 更新lengthInput
         * @param e
         */
        updateLength(e) {
            this.$store.commit('payFee/updateLengthInput', e.target.value)
        },

        /**
         * 更新widthInput
         * @param e
         */
        updateWidth(e) {
            this.$store.commit('payFee/updateWidthInput', e.target.value)
        },

        /**
         * 更新heightInput
         * @param e
         */
        updateHeight(e) {
            this.$store.commit('payFee/updateHeightInput', e.target.value)
        },
        /**
         * 打开DateTimePicker选择器
         */
        showDateTimePicker() {
            this.$refs.picker.open()
        },
        /**
         * 选择完时间点击确定按钮
         * @param data
         */
        handleConfirm(data) {
            const date = moment(data).format('YYYY-MM-DD')
            this.selectedDate = date
            this.showMyTimePickerFlg = true
        },
        /**
         * 是否显示“为什么要同时输入体积和重量”的说明弹框
         * @param showFlag
         */
        showVolumeAndWeightDesc(showFlag) {
            this.showVolumeAndWeightFlg = showFlag
        },
        handleCancelTime() {
            this.showMyTimePickerFlg = false
        },
        handleConfirmTime(myTime) {
            this.showMyTimePickerFlg = false
            this.sendTime = `${this.selectedDate} ${myTime}`
        }
    }
}
</script>

<style lang="scss" scoped>
input {
    border-bottom: none !important;
    padding: 10px 0;
}
.fm-item {
    padding: 20px 5px 20px 180px;
    border-bottom: $gray-light 1px solid;
    position: relative;
}
.fm-item label {
    position: absolute;
    left: 30px;
    padding: 10px 0;
}

.ui-collapsible-select {
    display: block;
    position: relative;
    .icon-wrapper {
        position: absolute;
        width: 36px;
        height: 36px;
        right: 30px;
        top: 10px;
    }
}
.fill-text {
    display: block;
    padding: 10px 0;
    color: $gray-light;
}
.label-cols {
    .label-box {
        display: block;
        padding: 5px 65px 5px 55px;
        position: relative;
        label {
            left: 0;
            bottom: 2px;
        }
        .unit {
            position: absolute;
            top: 9px;
            right: 30px;
            color: $gray;
        }
    }
}

.text-r {
    text-align: right;
    margin: 20px;
    span {
        color: $red;
    }
}
.grid-btn {
    text-align: center;
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-form.vue